import { privateApi } from '../ApiService';
import { JobylonCandidateByInternalIdResponse } from './types';

const fetchJobylonCandidateByInternalId = (
    jobylonInternalCandidateId: string,
): Promise<JobylonCandidateByInternalIdResponse> =>
    privateApi.get<JobylonCandidateByInternalIdResponse>(
        `jobylon/candidate-by-jobylon-internal-id/${jobylonInternalCandidateId}`,
    );

export const JobylonCandidateGateway = {
    fetchJobylonCandidateByInternalId,
};
